import { createTheme as o } from "./ghl-ui.es901.js";
import n from "./ghl-ui.es1192.js";
import r from "./ghl-ui.es1214.js";
import m from "./ghl-ui.es1212.js";
function c(e) {
  const {
    boxShadow2: t
  } = e;
  return {
    menuBoxShadow: t
  };
}
const i = o({
  name: "Select",
  common: n,
  peers: {
    InternalSelection: r,
    InternalSelectMenu: m
  },
  self: c
}), f = i;
export {
  f as default,
  c as self
};
